module.exports = __webpack_public_path__ + "configuration/config_pred.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=configuration/config_pred.json!./src/config/config_pred.json
// module id = 540
// module chunks = 3